(async () => {
    // Step 1: Extract the query parameters
    const queryParams = new URLSearchParams(window.location.search);

    // Check if the "items" parameter is present
    const itemsParam = queryParams.get('additems');
    if (!itemsParam) {
        //console.error('[Hallway:ATC Script] No "additems" parameter detected in the URL.');
        return;
    }

    // Extract variant_id:quantity pairs from the "items" parameter
    const cartData = itemsParam.split(',').filter(pair => pair.trim() !== '');
    if (cartData.length === 0) {
        console.error('[Hallway:ATC Script] The "additems" parameter is empty.');
        return;
    }

    const cartPayload = {
        items:
            cartData.map(pair => {
                const [id, quantity] = pair.split(':');
                return { id: parseInt(id, 10), quantity: parseInt(quantity || '1', 10) };
            })
    };

    // Step 2: Clear cart and add items using Shopify's AJAX API
    let newCart = {};
    try {

        const clearResponse = await fetch(`${window.Shopify.routes.root}cart/clear.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });

        if (!clearResponse.ok) {
            console.error(`[Hallway:ATC Script] Failed to clear the cart:`, await clearResponse.text());
            return;
        }

        const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(cartPayload),
        });

        if (!addResponse.ok) {
            console.error(`[Hallway:ATC Script] Failed to add item ${item.id} to cart:`, await addResponse.text());
            return;
        }

        // store the enriched cart contents for later use with Klaviyo
        newCart = await addResponse.json();

        console.log('[Hallway:ATC Script] Cleared cart and added new items successfully:', newCart);
    } catch (error) {
        console.error('[Hallway:ATC Script] Error adding items to cart:', error);
        return;
    }

    // Step 3: Apply discount code if present
    const discountCode = queryParams.get('discount');
    if (discountCode) {
        try {
            const response = await fetch(`${window.Shopify.routes.root}discount/${discountCode}`);
            if (!response.ok) {
                console.error('[Hallway:ATC Script] Failed to apply discount code:', await response.text());
                return;
            }
            console.log('[Hallway:ATC Script] Discount code applied successfully.');
        } catch (error) {
            console.error('[Hallway:ATC Script] Error applying discount code:', error);
            return;
        }
    }

    // Step 4: Track Klaviyo ATC event
    const klaviyoTrackParam = queryParams.get('klaviyotrack') || true;

    if(klaviyoTrackParam == 'true') {
        // track ATC event in Klaviyo before redirect
        var _learnq = window._learnq || [];
        _learnq.push(['track', 'Added to Cart', newCart, performRedirect]);
    } else {
        // just do the redirect
        performRedirect();
    }

    // Step 5: Handle redirects based on the "redirect" parameter
    function performRedirect() {
        const redirectParam = queryParams.get('redirect');
        if (redirectParam === 'cart') {
            window.location.href = `${window.Shopify.routes.root}cart`;
        } else if (redirectParam === 'checkout') {
            window.location.href = `${window.Shopify.routes.root}checkout`;
        } else {
            console.log('[Hallway:ATC Script] No valid redirect parameter provided; staying on the current page.');
        }
    }

})();
